import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
  Box,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import {
  COMPCODE,
  LOCCODE,
  CUSTOMER_API_02,
  SETTINGS_API_11,
  Country_API_02,
  Guesttype_01,
  STS,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import Slide from "@mui/material/Slide";
const NewCustomer = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const { state } = useLocation();
  const { selectedItem } = state || {};
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data4, setData4] = useState([]);
  const [error, setError] = useState(null);
  const [error1, setError1] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [search, setSearch] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const titles = ["Mr", "Mrs", "Ms"];
  const [isLoading, setIsLoading] = useState(true);
  const [datacustom, setDatacustom] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    NICPP: "",
    MEMBERSHIP: "",

    LOYALTYBARCODE: "",
    GUESTTYPE: "",
    GUESTREFCODE: "",
    TITLE: "",
    FIRSTNAME: "",
    LASTNAME: "",
    EMAIL: "",
    CONTACTNO: "",
    COUNTRY: "",
  });
  const isEdit = location.state?.actionText === "Edit";
  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        NICPP: selectedItem.NICPP,
        MEMBERSHIP: String(selectedItem.MEMBERSHIPCODE),
        LOYALTYBARCODE: selectedItem.LOYALTYBARCODE,
        GUESTTYPE: selectedItem.GUESTTYPE,
        GUESTREFCODE: selectedItem.GUESTREFCODE,
        TITLE: selectedItem.TITLE,
        FIRSTNAME: selectedItem.FIRSTNAME,
        LASTNAME: selectedItem.LASTNAME,
        EMAIL: selectedItem.EMAIL,
        CONTACTNO: selectedItem.CONTACTNO,
        COUNTRY: selectedItem.COUNTRY,
      });
    }
  }, [selectedItem]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    })); // Clear field-specific error on input
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(CUSTOMER_API_02, "get", {
          COMPCODE,
          LOCCODE,
          KEYWORD: "0",
        });
        setDatacustom(result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleConfirmClick = async () => {
    const {
      NICPP,
      MEMBERSHIP,

      TITLE,
      FIRSTNAME,
      LASTNAME,
      EMAIL,
      CONTACTNO,
      COUNTRY,
      LOYALTYBARCODE,
    } = selectedItemDetails;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const requiredFields = [
      { name: "NICPP", value: NICPP, label: "NIC/PP" },
      { name: "TITLE", value: TITLE, label: "Title" },
      { name: "FIRSTNAME", value: FIRSTNAME, label: "First Name" },
      { name: "LASTNAME", value: LASTNAME, label: "Last Name" },
      { name: "EMAIL", value: EMAIL, label: "Email" },
      { name: "CONTACTNO", value: CONTACTNO, label: "Contact Number" },
      { name: "COUNTRY", value: COUNTRY, label: "Country" },
      {
        name: "LOYALTYBARCODE",
        value: LOYALTYBARCODE,
        label: "Loyalty Barcode",
      },
    ];

    // Required field validation
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    // Duplication check
    if (datacustom) {
      const isDuplicate = datacustom.some((item) => {
        if (
          item.GUESTREFCODE !== selectedItemDetails.GUESTREFCODE &&
          (item.EMAIL?.toLowerCase() === EMAIL?.toLowerCase() ||
            item.CONTACTNO === CONTACTNO ||
            item.LOYALTYBARCODE === LOYALTYBARCODE)
        ) {
          return true;
        }
        return false;
      });

      if (isDuplicate) {
        const duplicateFields = [];
        if (
          datacustom.some(
            (item) => item.EMAIL?.toLowerCase() === EMAIL?.toLowerCase()
          )
        ) {
          duplicateFields.push("Email");
        }
        if (datacustom.some((item) => item.CONTACTNO === CONTACTNO)) {
          duplicateFields.push("Contact Number");
        }
        if (datacustom.some((item) => item.LOYALTYBARCODE === LOYALTYBARCODE)) {
          duplicateFields.push("Loyalty Barcode");
        }

        const duplicateMessage = `Duplicate detected: ${duplicateFields.join(
          ", "
        )} already exists.`;
        setSnackbarMessage(duplicateMessage); // Show specific error
        setOpenErrorSnackbar(true);
        return; // Stop submission if duplication found
      }
    }

    // Prepare payload and make API call
    const guestrefcode = selectedItem
      ? String(selectedItem.GUESTREFCODE || "")
      : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
      GUESTCODE: "",

      STS: CON_STATUS_ACTIVE,
      Enuser: USERNAME,
      LOCDATE: new Date().toISOString(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      GUESTREFCODE: guestrefcode,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(CUSTOMER_API_02, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      resetForm();
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
    setTimeout(() => {
      navigate("/customer");
    }, 2000);
  };

  const handleClearClick = () => {
    resetForm();
  };
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };
  const filteredData = data.filter((item) =>
    item.COUNTRY.toLowerCase().includes(search.toLowerCase())
  );

  const resetForm = () => {
    setSelectedItemDetails({
      NICPP: "",
      MEMBERSHIP: "",
      LOYALTYBARCODE: "",
      GUESTTYPE: "",
      GUESTREFCODE: "",
      TITLE: "",
      FIRSTNAME: "",
      LASTNAME: "",
      EMAIL: "",
      CONTACTNO: "",
      COUNTRY: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_11, "get", {
          COMPCODE,
          LOCCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData4(result);
      } catch (err) {
        setError(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(Country_API_02, "get", {
          Country: "",
        });
        setData(result);
      } catch (err) {
        setError(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(Guesttype_01, "get", {
          STS: CON_STATUS_ACTIVE,
        });
        setData2(result);
      } catch (err) {
        setError(err);
      }
    };
    fetchData();
  }, []);

  const handleInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[a-zA-Z\s]*$/;

    if (regex.test(value) && value.length < 40) {
      // Valid input: matches regex and is within 10-character limit
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error for this field
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value, // Update state with the valid input
      }));
    } else if (value.length > 0) {
      // Exceeds character limit
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Contact cannot exceed 40 characters.",
      }));
    } else {
      // Invalid format
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only letters, numbers, and spaces are allowed.",
      }));
    }
  };

  const handleNumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) && value.length <= 10) {
      // Valid input: matches regex and is within 10-character limit
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error for this field
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value, // Update state with the valid input
      }));
    } else if (value.length > 10) {
      // Exceeds character limit
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Contact cannot exceed 10 characters.",
      }));
    } else {
      // Invalid format
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numbers and floats are allowed.",
      }));
    }
  };

  const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Customer</Link>
                <Link underline="none">New Customer</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={() => navigate("/customer")}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit
              ? " Edit Customer Details"
              : "Create  Customer Details",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="NIC / PP No."
              size="small"
              fullWidth
              required
              variant="outlined"
              name="NICPP"
              value={selectedItemDetails.NICPP} // This should be a string or number, not an object
              onChange={handleInputChange}
              error={!!errors.NICPP}
              helperText={errors.NICPP}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl size="small" fullWidth>
              <Autocomplete
                options={data4 || []} // Ensure options is never null
                getOptionLabel={(option) => option.GROUPNAME || ""} // Display GROUPNAME in the dropdown
                value={
                  data4.find(
                    (item) =>
                      String(item.MEMBERSHIPCODE) ===
                      String(selectedItemDetails.MEMBERSHIP)
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "MEMBERSHIP",
                      value: newValue ? String(newValue.MEMBERSHIPCODE) : "", // Set MEMBERSHIPCODE when an option is selected
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Membership"
                    size="small"
                    error={!!errors.MEMBERSHIP}
                    helperText={errors.MEMBERSHIP || ""}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper, // Apply theme background
                  },
                }}
              />
            </FormControl>
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl fullWidth size="small">
              <Autocomplete
                options={titles}
                getOptionLabel={(option) => option}
                value={selectedItemDetails.TITLE}
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: { name: "TITLE", value: newValue },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Title"
                    size="small"
                    required
                    error={!!errors.TITLE}
                    helperText={errors.TITLE}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
                noOptionsText={
                  <div
                    style={{
                      backgroundColor: theme.palette.background.paper,
                      padding: "8px",
                    }}
                  >
                    No options
                  </div>
                }
              />
            </FormControl>
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Email"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              name="EMAIL"
              value={selectedItemDetails.EMAIL}
              onChange={handleInputEmailValidation}
              error={Boolean(errors.EMAIL)} // Set error state based on validation
              helperText={errors.EMAIL} // Display the error message
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="First Name"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              name="FIRSTNAME"
              value={selectedItemDetails.FIRSTNAME}
              onChange={handleInputValidation} // Ensure function is correctly used
              error={!!errors.FIRSTNAME}
              helperText={errors.FIRSTNAME}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Loyalty Barcode"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              name="LOYALTYBARCODE"
              value={selectedItemDetails.LOYALTYBARCODE}
              onChange={handleInputChange}
              error={!!errors.LOYALTYBARCODE}
              helperText={errors.LOYALTYBARCODE}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Last Name"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              name="LASTNAME"
              value={selectedItemDetails.LASTNAME}
              onChange={handleInputValidation} // Ensure function is correctly used
              error={!!errors.LASTNAME}
              helperText={errors.LASTNAME}
            />
          </Grid>

          {/* <Grid item xs={12} sm={12}>
              <FormControl size="small" fullWidth>
                <Autocomplete
                 
                  options={data2 || []} // Ensure options is never null
                  getOptionLabel={(option) => option.GUESTTYPE|| ""} // Show GROUPNAME in the dropdown
                  onChange={(event, value) => {
                    setSelectedItemDetails((prev) => ({
                      ...prev,
                      GUESTCODE: value ? value.GUESTCODE : "", // Store GROUPCODE in state
                      GUESTTYPE: value ? value.GUESTTYPE : "", // Store GROUPNAME in state
                    }));
                  }}
                  value={
                    data1
                      ? data2.find(
                          (option) => option.GUESTCODE == selectedItemDetails.GUESTCODE
                        ) || null // Select the appropriate option based on GROUPCODE
                      : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Guest Type"
                      size="small"
                      name="GUESTTYPE"
                      error={!!errors.GUESTTYPE}
                      helperText={errors.GUESTTYPE}
                     
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  isOptionEqualToValue={(option, value) => option === value}
                />
              </FormControl>
            </Grid> */}

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Contact No"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              name="CONTACTNO"
              value={selectedItemDetails.CONTACTNO}
              onChange={handleNumInputValidation} // Ensure correct function name
              error={!!errors.CONTACTNO}
              helperText={errors.CONTACTNO}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              id="country-autocomplete"
              options={data.map((item) => item.COUNTRY)}
              value={selectedItemDetails.COUNTRY}
              onChange={(event, newValue) =>
                handleInputChange({
                  target: { name: "COUNTRY", value: newValue },
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Country"
                  size="small"
                  fullWidth
                  required
                  error={!!errors.COUNTRY}
                  helperText={errors.COUNTRY}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
              noOptionsText={
                <div
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    padding: "8px",
                  }}
                >
                  No options
                </div>
              }
            />
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default NewCustomer;
